export default "__VITE_ASSET__g2sMa7m4__"